<template>
  <div class="top-bar" ref="topBarRef">
    <div class="extra-info">
      <slot name="title"></slot>
      <slot name="status"></slot>
    </div>
    <div class="user-info">
      <div class="switch-country" v-if="userInfo?.userType === 'seller'" ref="countryRef">
        <artmisads-select class="country" v-model:value="amazonCountryCode" @change="onChangeCountry"
          :getPopupContainer="() => $refs.countryRef">
          <template v-for="option in COUNTRY_BASE" :key="option.countryCode">
            <a-select-option class="country-select-item" :value="option.countryCode">
              <Icon :name="option.icon" class="icon"></Icon>
              <span>{{ option.host }}</span>
            </a-select-option>
          </template>
        </artmisads-select>
      </div>
      <div class="switch-lang" v-if="userInfo?.userType === 'seller'" ref="langRef" :title="t('seller.topBar.language')">
        <a-dropdown :getPopupContainer="() => langRef" trigger="click">
          <span class="lang-icon-trigger" role="button" tabindex="0">
            <svg class="qiehuanyuyan" aria-hidden="true" style="fill: rgba(15, 6, 41, .5)">
              <use xlink:href="#icon-qiehuanyuyan"></use>
            </svg>
          </span>
          <template #overlay>
            <a-menu class="seller-lang-menu" :selected-keys="[sellerLocaleModel]" @click="onSellerLangMenuClick">
              <a-menu-item key="en">{{ t('seller.lang.en') }}</a-menu-item>
              <a-menu-item key="zh-CN">{{ t('seller.lang.zhCN') }}</a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
      </div>
      <div class="message-icon" @click="userInfo?.userType === 'publisher' ? notificationsDrawerPublisherRef?.show() : notificationsDrawerRef?.show()" v-if="userInfo?.userType === 'publisher' ||userInfo?.userType === 'seller'">
        <div class="number" v-if="notificationsTotal">{{ notificationsTotal? notificationsTotal>99? '99+' : notificationsTotal : '0' }}</div>
        <svg class="icon" aria-hidden="true" style="fill: rgba(15, 6, 41, .5)">
          <use xlink:href="#icon-notification"></use>
        </svg>
      </div>
      <!-- userInfo.userType === 'publisher' ||  -->
      <div class="message-icon" @click="messageDrawerRef?.show()" v-if="userInfo?.userType === 'publisher' || userInfo?.userType === 'seller'">
        <div class="number" v-if="total">{{ total? total>99? '99+' : total : '0' }}</div>
        <svg class="icon" aria-hidden="true" style="fill: rgba(15, 6, 41, .5)">
          <use xlink:href="#icon-message"></use>
        </svg>
      </div>
     
      <a-dropdown :getPopupContainer="() => topBarRef">

        <svg class="icon" aria-hidden="true" style="fill: rgba(15, 6, 41, .5)">
          <use xlink:href="#icon-a-wode1"></use>
        </svg>
        <template #overlay>
          <div class="content">
            <div class="title-wrap">
              <a class="title" :href="linkUrl">
                <h3>
                  {{ store.userInfo?.userName || store.userInfo?.name || "" }}
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-jiantou-you-cu"></use>
                  </svg>
                </h3>
                <p>{{ store.userInfo?.email || "" }}</p>
              </a>
            </div>
            <artmisads-dropdown-menu>
              <a-menu-item key="2" @click="getAccounts" v-if="userInfo?.userType !== 'admin'">
                <div class="select-item">
                  <div class="sign-out">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-zhanghaoqiehuan" />
                    </svg>
                    <span>{{ userInfo?.userType === 'seller' ? t('seller.topBar.switchAccount') : 'Switch Account' }}</span>
                  </div>
                </div>
              </a-menu-item>
              <a-menu-item key="1" @click="onSignOut">
                <div class="select-item">
                  <div class="sign-out">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-tuichu" />
                    </svg>
                    <span>{{ userInfo?.userType === 'seller' ? t('seller.topBar.signOut') : 'Sign Out' }}</span>
                  </div>
                </div>
              </a-menu-item>
            </artmisads-dropdown-menu>
          </div>
        </template>
      </a-dropdown>
    </div>
    <artmisads-modal class="switch-account-modal" v-model:open="showSwitchAccountModal" width="800px" :footer="null"
      style="min-height: 320px" :title="userInfo?.userType === 'seller' ? t('seller.topBar.switchAccountModalTitle') : 'Switch Account'" @close="showSwitchAccountModal = false">
      <a-spin :spinning="loadingAccounts">
        <div class="switch-account-modal-content">
          <!-- 过滤主账号和当前子账号  -->
          <a-list bordered :data-source="accountsList.filter(item =>
            item.delegatorUserId !== item.delegateUserId &&
            !(userInfo?.delegateUserId == item.delegateUserId && userInfo?.delegatorUserId == item.delegatorUserId)
          )">
            <template #renderItem="{ item }">
              <a-list-item class="switch-account-item">
                <span class="name">{{ item.delegatorUserName }}</span>
                <span class="email">{{ item.delegatorUserEmail }}</span>
                <Status class="status" :type="item.status.toLowerCase()" :noBorder="true"
                  :text="item.status == 'INACTIVE' ? (userInfo?.userType === 'seller' ? t('seller.topBar.deactive') : 'Deactive') : (userInfo?.userType === 'seller' ? t('seller.topBar.active') : 'Active')" />
                <artmisads-select-button type="link" :disabled="item.status == 'INACTIVE'" class="status-btn"
                  :isSquare="true" size="small"
                  @click="onSwitchAccount(item.delegationId)">{{ userInfo?.userType === 'seller' ? t('seller.topBar.switch') : 'Switch' }}</artmisads-select-button>
              </a-list-item>
            </template>
          </a-list>
          <artmisads-button-special class="back-to-my-account" v-if="!userInfo?.isSelf && hasSelfAccount"
            @click="onSwitchAccount">
            <span class="btn-text">{{ userInfo?.userType === 'seller' ? t('seller.topBar.backToMyAccount') : 'Back To My Account' }}</span>
          </artmisads-button-special>
        </div>
      </a-spin>
    </artmisads-modal>
    <MessageDrawer 
      ref="messageDrawerRef"
      @close="loadMessages"
      @refresh="loadMessages"
    />
    <NotificationsDrawer 
      ref="notificationsDrawerRef"
      @close="loadNotifications"
      @refresh="loadNotifications"
    />
    <NotificationsDrawerPublisher 
      ref="notificationsDrawerPublisherRef"
      @close="loadNotifications"
      @refresh="loadNotifications"
    />
  </div>
</template>

<script setup>
import jwt from 'jsonwebtoken'
import Status from './Status.vue'
import { useRouter, useRoute } from 'vue-router'
import { onBeforeMount, ref, watch, onUnmounted, onMounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { persistSellerLocale } from '~/i18n'
import { COUNTRY_BASE,CURRENCY_MAPPER } from '../contants/common'
import { useUserInfoStore } from '../storeData/index'
import { storeToRefs } from 'pinia'
import { signApi, publisherAdminApi, adminApi, profileApi, homeApi } from '../server/index'
import Icon from './Icon.vue'
import MessageDrawer from './MessageDrawer.vue'
import NotificationsDrawer from './NotificationsDrawer.vue'
import NotificationsDrawerPublisher from './NotificationsDrawerPublisher.vue'
import { message } from 'ant-design-vue'
const router = useRouter()
const route = useRoute()
const store = useUserInfoStore()
const { userInfo } = storeToRefs(store)
const { t, locale } = useI18n()
const topBarRef = ref()

const langRef = ref(null)
const sellerLocaleModel = ref(locale.value)
watch(locale, (v) => {
  sellerLocaleModel.value = v
})
const onSellerLocaleChange = (val) => {
  locale.value = val
  const accountId = store.userInfo?.id ?? store.userInfo?.email
  persistSellerLocale(val, accountId)
  location.reload()
}
const onSellerLangMenuClick = ({ key }) => {
  if (key === locale.value) return
  onSellerLocaleChange(key)
}
const accountsList = ref([]) // 账号列表
const amazonCountryCode = ref()
// console.log(userInfo,'userInfo')
const loadingAccounts = ref(false) // 加载账号列表
const showSwitchAccountModal = ref(false)
const linkUrl = ref('')
const hasSelfAccount = ref(false)
const total = ref(0)
const notificationsTotal = ref(0)
const param={
  page: 1,
  size: 10000
}

// 定时器相关
const refreshTimer = ref(null)
const REFRESH_INTERVAL = 1 * 60 * 1000 // 1分钟
const isTimerActive = ref(false)



const messageDrawerRef = ref()
const notificationsDrawerRef = ref()
const notificationsDrawerPublisherRef = ref()
const loadMessages = async() => {
 
  if (userInfo.value?.userType === 'publisher') {
    await getMessagesListPublisher()
   
  } else if (userInfo.value?.userType === 'seller') {
    await getMessagesListSeller()
  }
 
}
const loadNotifications = async() => {
  if (userInfo.value?.userType === 'publisher') {
    // console.log('publisher用户')
    await getNotificationsUnreadCountPublisher()
  } else if (userInfo.value?.userType === 'seller') {
    await getNotificationsUnreadCountSeller()
  }
}
// 启动定时刷新
const startRefreshTimer = () => {
  // 只有publisher或seller用户才启动定时器
  if (!userInfo.value || (userInfo.value.userType !== 'publisher' && userInfo.value.userType !== 'seller')) {
    // console.log('用户类型不支持定时刷新:', userInfo?.userType)
    return
  }
  
  // 清除现有定时器
  stopRefreshTimer()
  
  // console.log('启动topBar定时刷新器，间隔:', REFRESH_INTERVAL / 1000, '秒')
  isTimerActive.value = true
  
  refreshTimer.value = setInterval(async () => {
    if (isTimerActive.value) {
      try {
        // console.log('topBar定时刷新消息列表')
        await loadMessages()
        await loadNotifications()
      } catch (error) {
        // console.error('topBar定时刷新消息失败:', error)
      }
    } else {
      // 如果定时器被禁用，停止定时器
      stopRefreshTimer()
    }
  }, REFRESH_INTERVAL)
}

// 停止定时刷新
const stopRefreshTimer = () => {
  if (refreshTimer.value) {
    // console.log('停止topBar定时刷新器')
    clearInterval(refreshTimer.value)
    refreshTimer.value = null
    isTimerActive.value = false
  }
}

// 暂停定时刷新
const pauseRefreshTimer = () => {
  isTimerActive.value = false
  // console.log('暂停topBar定时刷新器')
}

// 恢复定时刷新
const resumeRefreshTimer = () => {
  isTimerActive.value = true
  // console.log('恢复topBar定时刷新器')
}
const getMessagesListPublisher = async() => {
  const data = await homeApi.publisherMessagesList(param.value)
  if(data.success){
  
   // 计算所有消息的unreadCount累加值
   total.value = data.data.data.reduce((sum, message) => sum + (message.unreadCount || 0), 0)
  }else{
    message.error(data.error)
  }

}
const getNotificationsUnreadCountSeller = async() => {
  const data = await homeApi.sellerNotificationsUnreadCount(
    {
       marketplace:CURRENCY_MAPPER[userInfo.value?.countryCode]?.host
    }
  )
  if(data.success){
    // console.log(data)
    notificationsTotal.value = data.data.totalUnreadCount || 0
  }else{
    message.error(data.error)
  }
}
const getNotificationsUnreadCountPublisher = async() => {
  
  const data = await homeApi.publisherNotificationsUnreadCount(
    {
       marketplace:CURRENCY_MAPPER['US'].host
    }
  )
   
  if(data.success){
    notificationsTotal.value = data.data.totalUnreadCount || 0
  }else{
    message.error(data.error)
  }
}
const getMessagesListSeller = async() => {
  const data = await homeApi.sellerMessagesList(param.value)
 
  if(data.success){
    // 计算所有消息的unreadCount累加值
    total.value = data.data.data.reduce((sum, message) => sum + (message.unreadCount || 0), 0)
  }else{
    message.error(data.error)
  }

}
const onChangeCountry = async (e) => {
  store.setUserLoading(true)
  let res
  try {
    res = await adminApi.switchCountry({
      newCountryCode: e
    })
  } catch (error) {
    store.setUserLoading(false)
  }

  if (res.success) {
    const userToken = res.data.token
    const artmisAdsUserData = jwt.decode(userToken)
    store.setUserInfo(artmisAdsUserData, userToken, store.userInfo.menus)
    router.go(0)

  } else {
    message.error('please try again', 1)
  }
  store.setUserLoading(false)
}
const onSignOut = async () => {
  let res
  if (userInfo.value?.userType === 'admin') {
    res = await publisherAdminApi.signOut()
  } else {
    res = await signApi.signOut()
  }
  const { success, error, code } = res
  if (success || code === '3008' || code === '3009' || code === '3010') {
    locale.value = 'en'
    persistSellerLocale('en')
  
    if (userInfo.value?.userType === 'admin') {
      store.setUserInfo('')
      location.href = '/operator/login'
    } else {
      store.setUserInfo('')
      location.href =
        userInfo.value?.userType === 'seller' ? '/sign-in?seller=1' : '/sign-in'
    }
  } else {
    // console.log(error)
  }
}
// 获取账号列表
const getAccounts = () => {
  loadingAccounts.value = true
  showSwitchAccountModal.value = true

  profileApi.getAccounts().then(res => {
    const { data, success, error } = res

    loadingAccounts.value = false

    if (success) {
      accountsList.value = data
      hasSelfAccount.value = data.findIndex(item => item.delegateUserId === item.delegatorUserId) > -1
    }
  })
}

// 切换账号
const onSwitchAccount = (delegationId) => {
  // 切回主账号
  if (delegationId.type) {
    // 找到主账号ID
    delegationId = accountsList.value.filter(item => item.delegateUserId === item.delegatorUserId)[0].delegationId
  }

  loadingAccounts.value = true

  profileApi.switchAccount(delegationId).then(res => {
    const { success, error } = res

    if (success) {
      const { menu, token } = res.data
      const artmisAdsUserData = jwt.decode(token)

      store.setUserInfo(artmisAdsUserData, token, menu)

      let href = ''

      if (menu) {
        if (menu.children[0].children) {
          href = menu.children[0].children[0].path
        } else {
          href = menu.children[0].path
        }

        linkUrl.value = href // 更新顶部头像链接
        location.href = location.origin + href // 跳转当前用户能访问到的第一个页面
      } else {
        router.go(0) // 刷新当前页面
      }

      showSwitchAccountModal.value = false
    } else {
      loadingAccounts.value = false
      message.error(error)
    }
  })
}
onMounted(() => {
  // 使用setTimeout确保组件完全挂载
  setTimeout(() => {
    if(route?.query?.notificationSettings){
      // console.log('执行',notificationsDrawerRef)
      // console.log('notificationsDrawerRef.value:', notificationsDrawerRef.value)
      if (notificationsDrawerRef.value) {
        // console.log('notificationsDrawerRef.value.show:', notificationsDrawerRef.value.show)
        if (typeof notificationsDrawerRef.value.show === 'function') {
          notificationsDrawerRef.value.show('notificationSettings')
        } else {
          // console.error('notificationsDrawerRef.show is not a function')
          // 尝试直接访问组件实例的方法
          // console.log('直接访问组件实例:', notificationsDrawerRef)
        }
      } else {
        // console.error('notificationsDrawerRef.value is null')
      }
    }
  }, 500)
})
onBeforeMount(() => {
  let link = '/seller/dashboard'

  const currentUser = userInfo.value

  if (currentUser) {
    if (currentUser.status === 'PENDING_CHOOSE_TYPE') {
      link = '/profile'
    }
    if (currentUser.userType === 'publisher') {
      link = '/publisher/dashboard'
      if (currentUser.reviewStatus === 'Rejected') {
        link = '/profile'
      }
    }
    if (currentUser.userType === 'admin') {
      link = '/operator/users'
    }
  }

  if (currentUser?.menus) {
    if (currentUser.menus.children[0].children) {
      link = currentUser.menus.children[0].children[0].path
    } else {
      link = currentUser.menus.children[0].path
    }
  }
 
  // if (userInfo.userType === 'publisher') {
  //   getMessagesListPublisher()
  // }
  // if(userInfo.userType === 'seller'){
  //   getMessagesListSeller()
  // }
  linkUrl.value = link
  
  // 启动定时刷新
  startRefreshTimer()
})

watch(() => userInfo.value?.countryCode, () => {
  amazonCountryCode.value = userInfo.value?.countryCode
  loadMessages()
  loadNotifications()
}, { immediate: true })

// 监听用户类型变化，重新启动定时器
watch(() => userInfo.value?.userType, () => {
  if (userInfo.value?.userType === 'publisher' || userInfo.value?.userType === 'seller') {
    startRefreshTimer()
  } else {
    stopRefreshTimer()
  }
})

// 组件销毁时清理定时器
onUnmounted(() => {
  stopRefreshTimer()

})
</script>
<style lang="less">

.switch-account-modal {
  .back-to-my-account {
    margin-top: 16px;
  }

  .ant-modal-body {
    min-height: 264px;
    padding-bottom: 16px !important;
  }

  .ant-modal-footer {
    justify-content: center;
  }

  .ant-list {
    border-color: var(--border-1);
  }
}
</style>
<style lang="less" scoped>
@import '../assets/less/country-select.less';
.message-icon{
  width: 24px;
  height: 100%;
  display: flex;
  align-items: center;
  position: relative;
  .icon{
    font-size: 24px;
    cursor: pointer;
  }
  margin-right: 18px;
}
.qiehuanyuyan{
 width: 24px;
 height: 24px;
  cursor: pointer;
}
.number{
  background-color: #EB4E3D;
  border-radius: 16px;
  height: 16px;
  padding: 0.8px 4.8px 0 4.8px;
  position: absolute;
  top: 6px;
  right: -5px;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.3px;
}
.top-bar {
  z-index: 99;
  width: 100%;
  height: 48px;
  min-height: 48px;
  background: var(--color-white);
  box-shadow: var(--section-box-shadow-5);
  display: flex;
  justify-content: space-between;
  padding-left: 27px;
  padding-right: 16px;
  position: relative;

  .content {
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    background: var(--color-white);
  }

  :deep(.ant-dropdown-menu) {
    box-shadow: none;
    padding: 8px;

    .ant-dropdown-menu-item {
      padding: 8px;
    }
  }

  :deep(.ant-modal-footer) {
    justify-content: center;
  }

  >svg {
    width: 24px;
    height: 24px;
    align-self: center;
  }

  .user-info {
    flex: 1;
    display: flex;
    justify-content: right;

    >svg {
      width: 24px;
      height: 24px;
      align-self: center;
      cursor: pointer;
    }
  }

  .switch-country {
    align-content: center;
    display: flex;
    align-items: center;
    height: 100%;
    margin-right: 18px;
  }
  .switch-lang{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 18px;
    .lang-icon-trigger {
      display: inline-flex;
      cursor: pointer;
      line-height: 0;
    }
    .qiehuanyuyan {
      width: 24px;
      height: 24px;
    }
  }
  .title-wrap {
    padding: 8px;
    border-bottom: 1px solid #E8E5ED;
  }

  .title {
    display: block;
    width: 256px;
    padding: 8px 14px 4px 14px;

    border-radius: 8px;

    &:hover {
      background-color: var(--bg-gray-6);
    }

    >h3 {
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 0.4px;
      line-height: 19px;
      color: var(--dark-2);

      svg {
        width: 13px;
        height: 13px;
        margin-left: 4px;
        fill: var(--dark-2);
        vertical-align: -1px;
      }
    }

    >p {
      margin-top: 2px;
      opacity: 0.5;
      font-weight: 400;
      font-size: 13px;
      color: #0E0528;
      letter-spacing: 0.4px;
      line-height: 18px;
    }
  }

  .sign-out {
    cursor: pointer;
    display: flex;

    >svg {
      width: 20px;
      height: 20px;
      margin-right: 12px;
      margin-left: 8px;
      align-self: center;
      fill: var(--dark-1);
    }

    >span {
      color: var(--dark-1);
      font-family: Sora, sans-serif;
      letter-spacing: 0.4px;
      line-height: 19px;
    }
  }
}

.extra-info {
  display: flex;
  justify-content: left;
  align-items: center;
}

.switch-account-item {
  gap: 16px;
  border-block-end: 1px solid var(--border-1);

  >.name {
    flex: 0 0 120px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  >.email {
    flex: 1
  }

  >.status {
    flex: 0 0 82px;
    text-align: left;
  }
}
</style>